import {
    createSelector,
} from '@reduxjs/toolkit';
import {
    selectIsMobile,
    selectIsHybrid,
    selectAllowLogin,
} from '~SpectateStore/selectors/clientStateSliceSelectors';
import {
    selectIsUserLoggedIn,
    selectLoginRestricted,
} from '~SpectateStore/selectors/userSliceSelectors';


export const selectShouldHideLogin = createSelector(
    selectIsUserLoggedIn,
    selectLoginRestricted,
    selectIsMobile,
    selectIsHybrid,
    selectAllowLogin,
    (isUserLoggedIn, isLoginRestricted, isMobile, isHybrid, allowLogin) => {

        if (allowLogin !== undefined) {
            return !allowLogin;
        }

        return !isUserLoggedIn
            && isLoginRestricted
            && isMobile
            && !isHybrid;
    }
);
